var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.72201H8.66667V1.05534C8.66667 0.878528 8.59643 0.708958 8.47141 0.583934C8.34638 0.45891 8.17681 0.388672 8 0.388672V0.388672C7.82319 0.388672 7.65362 0.45891 7.5286 0.583934C7.40357 0.708958 7.33333 0.878528 7.33333 1.05534V7.72201H0.666667C0.489856 7.72201 0.320286 7.79224 0.195262 7.91727C0.0702379 8.04229 0 8.21186 0 8.38867H0C0 8.56548 0.0702379 8.73505 0.195262 8.86008C0.320286 8.9851 0.489856 9.05534 0.666667 9.05534H7.33333V15.722C7.33333 15.8988 7.40357 16.0684 7.5286 16.1934C7.65362 16.3184 7.82319 16.3887 8 16.3887C8.17681 16.3887 8.34638 16.3184 8.47141 16.1934C8.59643 16.0684 8.66667 15.8988 8.66667 15.722V9.05534H15.3333C15.5101 9.05534 15.6797 8.9851 15.8047 8.86008C15.9298 8.73505 16 8.56548 16 8.38867C16 8.21186 15.9298 8.04229 15.8047 7.91727C15.6797 7.79224 15.5101 7.72201 15.3333 7.72201Z",
    fill: "#333335"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.3f07fe3d.svg";
export { ForwardRef as ReactComponent };